import clsx from 'clsx';
import { TableHeaderColumnProps } from './Table.types';
import SortingIcon from '../icons/Sorting';
import { SortState } from '@shared/types/general';
import React, { useMemo } from 'react';
import { twMerge } from '@shared/utils/twMerge';

export const TableHeaderColumn = <T,>({
  column,
  index,
  onSort,
  styles,
  sortState,
  isFirstColumn,
  isLastColumn,
  darkMode,
}: TableHeaderColumnProps<T>) => {
  const sortBy = useMemo<SortState>(() => {
    if (sortState) {
      const [sortColumn, sortOrder] = sortState.split(',');

      if (sortColumn === column.name) {
        return sortOrder as SortState;
      }
    }
    return 'none';
  }, [column.name, sortState]);

  const toggleSort = () => {
    if (!column.hasSorting) {
      return;
    }
    if (!sortState || !sortState?.includes(column.name)) {
      onSort && onSort(column.name, 'asc');
      return;
    }
    if (sortState?.includes('asc')) {
      onSort && onSort(column.name, 'desc');
      return;
    } else {
      onSort && onSort(column.name);
      return;
    }
  };
  return (
    <th
      key={index}
      style={column.thStyle}
      className={twMerge(
        'mini:py-1 sticky top-0 p-0 py-2',
        darkMode ? 'bg-darkCharcoal th-bordered-dark' : 'th-bordered bg-[#f6f9ff]',
        styles?.th,
        column?.thClassName
      )}
    >
      <div
        data-testid={'table-header-cell'}
        style={column.headerStyle}
        onClick={toggleSort}
        className={clsx(
          'mini:text-1216 text-1424 flex items-center font-medium',
          darkMode ? 'text-white' : 'text-spanishGray',
          isFirstColumn ? 'mini:pl-2 pl-3' : 'px-1',
          column.alignToRight ? 'justify-end' : 'justify-start',
          isLastColumn ? 'mini:pl-2 pr-3' : '',
          {
            'cursor-pointer': column.hasSorting,
          },
          styles?.headerCell,
          column?.headerClassName
        )}
      >
        {column.header(index)}
        {column.hasSorting && (
          <div className="ml-1">
            <SortingIcon dir={sortBy} />
          </div>
        )}
      </div>
    </th>
  );
};
